module.exports = __webpack_public_path__ + "static/media/company.8ef1c634.jpg";